module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('Form', [_c('FormItem', {
    attrs: {
      "label": _vm.l('JIHUAMINGCHENG')
    }
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('NIANDU')
    }
  }, [_vm._v(_vm._s(_vm.item.year) + _vm._s(_vm.l("NIAN")))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('YUEFEN')
    }
  }, [_vm._v(_vm._s(_vm.item.month) + _vm._s(_vm.l("YUE")))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('SUOSHUZUZHI')
    }
  }, [_vm._v(_vm._s(_vm.item.domainName))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('GUANLIWEIDU')
    }
  }, [_vm._v(_vm._s(_vm.item.dimensionNames))])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('KECHENGMULU')
    }
  }, [_vm._v(_vm._s(_vm.item.courseTypeName))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('PEIXUNNEIRONG')
    }
  }, [_vm._v(_vm._s(_vm.item.name))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('PEIXUNDUIXIANG')
    }
  }, [_vm._v(_vm._s(_vm.item.trainObject))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('PEIXUNXINGSHI')
    }
  }, [_vm._v(_vm._s(_vm.item.trainFormName))])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('PEIXUNLEIXING')
    }
  }, [_vm._v(_vm._s(_vm.item.trainTypeName))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('KAOHEFANGSHI')
    }
  }, [_vm._v(_vm._s(_vm.item.testMethodName))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('PEIXUNDIZHI')
    }
  }, [_vm._v(_vm._s(_vm.item.trainAddress))])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('YUSUANHEJI')
    }
  }, [_vm._v(_vm._s(_vm.item.expenseBudget))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('RENCIHEJI')
    }
  }, [_vm._v(_vm._s(_vm.item.expectedPeoples))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('KESHIHEJI')
    }
  }, [_vm._v(_vm._s(_vm.item.expectedClassHours))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('NIFUXUEFEN')
    }
  }, [_vm._v(_vm._s(_vm.item.credit || _vm.l("ZANWU")))])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('PEIXUNJIBIE')
    }
  }, [_vm._v(_vm._s(_vm.item.trainingLevel || _vm.l("ZANWU")))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('PEIXUNZHUYAONEIRONG')
    }
  }, [_vm._v(_vm._s(_vm.item.trainingContent))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('GUANLIANNIANDUJIHUA')
    }
  }, [_vm._v(_vm._s(_vm.item.yearName || _vm.l("ZANWU")))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('SHISHIBUMEN')
    }
  }, [_vm._v(_vm._s(_vm.item.orgName))])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "24"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('JIANGSHI')
    }
  }, [_vm._v(_vm._s(_vm.item.teacherNames))])], 1)], 1), _vm._v(" "), _c('Row', [(_vm.item.changePlan == 'Y') ? _c('Col', {
    attrs: {
      "span": "24"
    }
  }, [_c('Alert', {
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.l('BIANGENGYUANYING')) + "\n          "), _c('span', {
    attrs: {
      "slot": "desc"
    },
    slot: "desc"
  }, [_vm._v(_vm._s(_vm.item.changeReason))])])], 1) : _vm._e(), _vm._v(" "), _c('Divider', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.l('BIANGENGJIHUALISHI')))]), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "24"
    }
  }, [_c('el-table', {
    staticClass: "m-t",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "data": _vm.item.changeList,
      "border": "",
      "size": "small"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.l('YUEFEN'),
      "prop": "month",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.l('KECHENGMULU'),
      "prop": "courseTypeName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.l('PEIXUNNEIRONG'),
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.l('PEIXUNDUIXIANG'),
      "prop": "trainObject"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.l('YUSUANHEJI'),
      "prop": "expenseBudget",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.l('RENCIHEJI'),
      "prop": "expectedPeoples",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.l('KESHIHEJI'),
      "prop": "expectedClassHours",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.l('PEIXUNZHUYAONEIRONG'),
      "prop": "trainingContent"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.l('SHIJIANFANWEI'),
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.startTime) + " - " + _vm._s(scope.row.endTime))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "300",
      "label": _vm.l('BIANGENGYUANYING'),
      "prop": "changeReason"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d2c3d4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":true}!./src/shared/views/monthPlan.vue
// module id = 932
// module chunks = 80